module.exports = __webpack_public_path__ + "static/media/wavm8s-017-otang.635652e.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/wav/wavm8s-017-otang.mp3
// module id = w8DS
// module chunks = 0